module.exports = __webpack_public_path__ + "img/Platacierinox_2.64db4aff.jpg";